import { useAuth } from "@entities/auth";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { UserDetailsResponse } from "@shared/lib/types/user";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { ME_QUERY_KEY } from "../../constants";

export function useGetMe() {
  const { user, getMe } = useAuth();
  const { data, isLoading, isError, error, isSuccess, refetch } = useQuery<
    BackednResponse<UserDetailsResponse>
  >({
    queryKey: ME_QUERY_KEY,
    queryFn: () => getMe(),
    enabled: !!user,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    userDetails: data?.data || null,
    isFetching: isLoading,
    isError,
    isSuccess,
    refetchUserDetails: refetch,
  };
}
